import React from 'react';
import * as icons from 'react-icons/fa';
import { motion } from 'framer-motion';

const DownloadItems = ({ freethings }) => {
  // সমস্ত সম্ভাব্য আইকনের ম্যাপিং
  const iconComponents = {
    FaDownload: icons.FaDownload,
    FaFilePdf: icons.FaFilePdf,
    FaBookOpen: icons.FaBookOpen,
    FaUser: icons.FaUser,
    FaHome: icons.FaHome,
    // অন্যান্য আইকন এখানে যোগ করুন
  };

  // আইকন কম্পোনেন্ট নির্বাচনের ফাংশন
  const getIconComponent = (iconName, props = {}) => {
    const Icon = iconComponents[iconName] || icons.FaBookOpen; // ডিফল্ট আইকন
    return <Icon {...props} />;
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      className="mb-8 px-4 sm:px-0"
    >
      {freethings.map((item, index) => (
        <motion.div 
          key={index}
          className="relative overflow-hidden rounded-2xl shadow-xl border border-blue-100 mb-6"
        >
          {/* ডেকোরেটিভ গ্রেডিয়েন্ট ব্যাকগ্রাউন্ড */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-50 opacity-80"></div>
          
          {/* ফ্লোটিং আইকন (ডাটাবেস থেকে নেওয়া) */}
          <motion.div
            animate={{
              y: [0, -5, 0],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            className="absolute -top-6 -right-6 text-blue-200 opacity-60"
            style={{ fontSize: '6rem' }}
          >
            {getIconComponent(item.icon)}
          </motion.div>

          <div className="relative z-10 p-6">
            {/* হেডার সেকশন - আইকন সহ */}
            <div className="flex items-center mb-4">
              <div className="bg-white p-3 rounded-xl shadow-sm mr-4">
                {getIconComponent(item.icon, { className: "text-blue-600 text-xl" })}
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800">{item.title}</h3>
                <p className="text-blue-600 text-sm font-medium">{item.subtitle}</p>
              </div>
            </div>

            {/* বিবরণ */}
            <p className="text-gray-600 mb-6 pl-2 border-l-4 border-blue-200">
              {item.description}
            </p>

            {/* ডাউনলোড বাটন অ্যানিমেশন সহ */}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => window.open(item.downloadLink, '_blank')}
              className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-4 px-6 rounded-xl font-bold shadow-lg flex items-center justify-center"
            >
              <motion.span
                animate={{
                  y: [0, -3, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                }}
              >
                {getIconComponent(item.button_icon, { className: "mr-3 text-lg" })}
              </motion.span>
              <span>{item.button_text}</span>
            </motion.button>
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default DownloadItems;